import { Container } from 'pixi.js';
import type { Signal } from 'typed-signals';
import { VersusTopBarLayout } from '../../layouts/gameJam/VersusTopBarLayout';
import Lerper from '../utils/Lerper';
import { playLayoutAnimation } from '../libs/layouts/layoutAnimations/playLayoutAnimation';

export interface VersusTopBarViewParams {
  onPlayerProgressUpdate: Signal<(progress: number) => void>;
  onEnemyProgressUpdate: Signal<(progress: number) => void>;
}

export class VersusTopBarView extends Container {
  private readonly layout = new VersusTopBarLayout();

  private readonly playerProgressLerper = new Lerper({
    displayObject: this.layout.root, initValue: 0,
    lerp: 0.1,
    onChange: (normProgress): void => {
      const { playerProgress, playerProgressBar } = this.layout;
      playerProgress.text = `${Math.floor(normProgress * 100)}%`;
      playerProgressBar.width = playerProgressBar.data.minWidth + (playerProgressBar.data.maxWidth - playerProgressBar.data.minWidth) * normProgress;
    },
  });

  private readonly enemyProgressLerper = new Lerper({
    displayObject: this.layout.root, initValue: 0,
    lerp: 0.1,
    onChange: (normProgress): void => {
      const { enemyProgress, enemyProgressBar, enemyProgressBarOverlay } = this.layout;
      enemyProgress.text = `${Math.floor(normProgress * 100)}%`;
      enemyProgressBar.width = enemyProgressBar.data.minWidth + (enemyProgressBar.data.maxWidth - enemyProgressBar.data.minWidth) * normProgress;
      enemyProgressBarOverlay.width = enemyProgressBar.width;
    },
  });

  constructor(params: VersusTopBarViewParams) {
    super();

    this.layout.root.props({ parent: this });

    params.onPlayerProgressUpdate.connect((normProgress) => {
      this.updatePlayerProgress(normProgress);
    });

    params.onEnemyProgressUpdate.connect((normProgress) => {
      this.updateEnemyProgress(normProgress);
    });
  }

  private highlightAnimation: Promise<void> | null = null;

  private updateEnemyProgress(normProgress: number): void {
    this.enemyProgressLerper.setTarget(normProgress);
    if (!this.highlightAnimation) {
      this.highlightAnimation = playLayoutAnimation(this.layout, 'highlightEnemyProgress');
      this.highlightAnimation.then(() => {
        this.highlightAnimation = null;
      }, () => {});
    }
  }

  private updatePlayerProgress(normProgress: number): void {
    this.playerProgressLerper.setTarget(normProgress);
  }
}
